export const RESET_DATATABLES_FILTER = 'RESET_DATATABLES_FILTER';
export const SET_DATATABLES_FILTER_VALUE = 'SET_DATATABLES_FILTER_VALUE';
export const SET_DATATABLES_CHECKED_FILTER_VALUE = 'SET_DATATABLES_CHECKED_FILTER_VALUE'